import state from './laborState'
import mutations from './laborMutations'
import actions from './laborActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
